import { useRouter } from 'next/router';

export default function useSlug() {
    const router = useRouter();
    return router.query.slug as string;
}
